import { createAction } from '@reduxjs/toolkit';

import { AppModalsEnum } from '@app/enums';
export const setModalDataAction = createAction<{
    modalName: AppModalsEnum;
    modalData?: unknown;
}>('common-ui/set-modal-data');

export const resetModalDataAction = createAction<AppModalsEnum>('common-ui/reset-modal-data');
